<template>
<div class="hotWord">
      
    <a-spin :spinning="spinning" size="large" tip="加载中...">
    <headerComponent></headerComponent>
    <div class="banner">
        <div class="hotword1">社媒热点</div>
         <a-input-search
      v-model:value="value"
      placeholder="请输入搜索内容"
      enter-button="搜索"
      size="large"
      @search="onSearch"
    />
    </div>
    <div class="all">
        <a-row>
            <a-col  v-show="list.isShow" :span="6" v-for="(list,index) in dataList" :key="list.id">
                <div class="box1">
                    <span class="mt">{{list.name}}</span>
                    <span class="rd"  v-if="!(list.name=='B站热搜'||list.name=='微博话题榜单'||list.name=='淘宝搜索热榜')">热度</span>
                </div>
                <div class="box2">
                    <div class="noData" v-if="!dataList[index].text">
                        <img src="../../assets/image/noData.png" alt="">
                        <div>暂无数据</div>
                    </div>
                    <div class="text" :class="{text2:!list1.topUrl}" @click="turnPath(list1.topUrl)" v-for="(list1,index1) in dataList[index].text" :key="list1.id">
                        <div class="number">{{index1+1}}</div>
                        <div :class="{test2:list1.subTitle}" class="text1">{{list1.title}}</div>
                        <div v-if="list1.subTitle" class="test3">{{list1.subTitle}}</div>
                        <div class="hot"  v-if="!(list.name=='B站热搜'||list.name=='微博话题榜单'||list.name=='淘宝搜索热榜')">{{formatNum(list1.topNum)}}</div>
                    </div>
                </div>
                <div class="box3">
                    <div class="time">更新时间</div>
                    <div class="time1">{{switchTime(list.receiveDate)}}</div>
                </div>
            </a-col>
            <div style="clear:both"></div>
  </a-row>
    </div>
    </a-spin>
     <div class="hoverBottomWapper"> 
      <div class="hoverBottom1">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
    </div>
    </div>
</div>
</template>

<script>
import { message } from 'ant-design-vue'
import headerComponent from '../../components/hotHeader'
import { getHotList,getHotDetail1 } from '../../utils/api'
export default {
components: {
    headerComponent
  },
  data(){
      return{
        value:"",
        dataList:[],
        visible:true,
        spinning:true,
        form:{
            pageNum:1,
            pageSize:10,
            orderByColumn:'topNum'
        }
      }
  },
  mounted(){
      this.getList()
  },
methods : {
    switchTime(val){
        if(val){
            return val.substring(0,val.indexOf(' ')).replace(/\//g,'-')
        }else{
            return ''
        }
    },
    turnPath(index){
        if(index){
         window.open(index)
        }
    },
    async switchId(id){
        let that = this
        getHotDetail1(id,that.form).then(res=>{
            that.spinning = false;
            if(res.rows){
                that.dataList.map((cur,index)=>{
                    if(id==cur.id){
                        that.dataList[index].receiveDate = res.rows[0].receiveDate
                        that.dataList[index].text = res.rows
                        if(res.rows.length<5){
                            that.dataList[index].isShow = false;
                        }else{
                            that.dataList[index].isShow = true;
                        }
                    }
                })
            }else{
                 that.dataList.map((cur,index)=>{
                    if(id==cur.id){
                        that.dataList.splice(index,1)
                    }
                })
            }
        })
    },
    async getList(){
        let that = this
        await getHotList().then(res=>{
            that.dataList = res.rows
            res.rows.map((cur,index)=>{
                that.switchId(cur.id)
            })
        })
    },
     formatNum(n){
            // if(!n){
            //     return ''
            // }
            // if(n==99999999){
            //     return ''
            // }
            if(n<0||!n){
                return 0
            }
         
            let num = n.toString()
            let decimals = ''
                // 判断是否有小数
            num.indexOf('.') > -1 ? decimals = num.split('.')[1] : decimals
            let len = num.length
            if (len <= 3) {
                return num
            } else {
                let temp = ''
                let remainder = len % 3
                decimals ? temp = '.' + decimals : temp
                if (remainder > 0) { // 不是3的整数倍
                    return num.slice(0, remainder) + ',' + num.slice(remainder, len).match(/\d{3}/g).join(',') + temp
                } else { // 是3的整数倍
                    return num.slice(0, len).match(/\d{3}/g).join(',') + temp
                }
            }
        },
    onSearch(){
        if(this.value==''){
            message.error('请输入搜索内容')
            return
        }
        this.$router.push({
            path:"searchResult",
            query:{
                title:this.value
            }
        })
    }
}
}
</script>

<style lang="scss" scoped>
.hotWord{
    min-height: 100vh;
    background-color: #333;
    font-family: 'NotoSansSC',sans-serif!important;
    position: relative;
     .hoverBottomWapper{
    width: 100%;
    background-color: #333;
    padding-bottom: 10px;
    .hoverBottom1{
      position: relative;
      width:100%;
      // text-align:center;
      //  padding:0px 0 10px 0;
      width:fit-content;
      margin: 0 auto;
      display: block;
      text-align:center;
       p>a{
          color: rgb(147, 147, 147);
           position: relative;
          padding-bottom: 5px;
          &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
    }
  }
    /deep/.ant-spin-blur{
        opacity: .75;
    }
    /deep/.ant-spin-nested-loading > div > .ant-spin{
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        z-index: 99;
    }
    /deep/.ant-spin-container::after{
        // background-color: transparent;
        display: none;
    }
    /deep/.ant-spin{
        color: #62f662;
        font-size: 30px;
        .ant-spin-dot-item{
            background-color: #62f662;
        }
    }
    .noData{
        text-align: center;
        padding: 20px 0;
        img{
            width: 60px;
        }
        div{
            font-size: 16px;
            margin-top: 10px;
        }
    }
    .box3{
        width: 100%;
        border-radius: 0px 0px 7px 7px;
        background-color: #000000;
        color: #FFFFFF;
        font-size: 20px;
        padding: 10px 10px 10px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .text{
        padding: 15px 10px 0px 0;
        font-size: 16px;
        display: flex;
        align-items: center;
        cursor: pointer;
        &.text2{
            cursor: default;
            .text1{
                &::after{
                    display: none;
                }
                &:hover{
                    color: rgba(0, 0, 0, 0.85);
                }
            }
            .test3{
                &::after{
                    display: none;
                }
                &:hover{
                    color: rgba(0, 0, 0, 0.85);
                }
            }
        }
    }
    .hot{
        margin-left: 15px;
        flex: 1;
        text-align: right;
    }
    .number{
        width: 30px;
        margin-left: 20px;
        text-align: left;
    }
    .test3{
        overflow: hidden;/*超出部分隐藏*/
        text-overflow:ellipsis;/* 超出部分显示省略号 */
        white-space: nowrap;/*规定段落中的文本不进行换行 */
        max-width: 33%;
        font-size: 16px;
        margin-left: 2%;
        position: relative;
        &::after{
            content: "";
            display: block;
            height: auto;
            border-bottom: 0!important;
            background-image: linear-gradient(#00f000,#00f000);
            text-decoration: none;
            padding-bottom: 2px;
            background-position: 0 100%;
            background-repeat: no-repeat;
            background-size: 0 2px;
            transition: background-size .3s;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
        }
        &:hover{
            color: #00F000;
            // border-bottom: 1px solid #00F000;
            // background-size: 100% 2px
            &::after{
                background-size: 100% 2px
            }
        }
    }
    .text1{
        overflow: hidden;/*超出部分隐藏*/
        text-overflow:ellipsis;/* 超出部分显示省略号 */
        white-space: nowrap;/*规定段落中的文本不进行换行 */
        width: 65.81%;
        font-size: 16px;
        position: relative;
        &.test2{
            width: 33%;
        }
        &::after{
            content: "";
            display: block;
            height: auto;
            border-bottom: 0!important;
            background-image: linear-gradient(#00f000,#00f000);
            text-decoration: none;
            padding-bottom: 2px;
            background-position: 0 100%;
            background-repeat: no-repeat;
            background-size: 0 2px;
            transition: background-size .3s;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
        }
        &:hover{
            color: #00F000;
            // border-bottom: 1px solid #00F000;
            // background-size: 100% 2px
            &::after{
                background-size: 100% 2px
            }
        }
    }
     /deep/.ant-input-search{
            .ant-input{
                &:focus{
                    border-bottom: 2px solid #00f000;
                }
            }
    }
    .box2{
        font-size: 11px;
        background-color: #FFFFFF;
        padding-bottom: 11px;
        border-bottom: 1px solid #00F000;
    }
    .box1{
        width: 100%;
        padding: 20px 10px 19px 20px;
        background-color: #000000;
        border-bottom: 1px solid #00F000;
        border-radius: 7px 7px 0px 0px;
    }
    .mt{
        font-size: 20px;
        color: #FFFFFF;
    }
    .rd{
        font-size: 20px;
        color: #FFFFFF;
        float: right;
        font-weight: bold;
    }
    .ant-col-6{
        width: 24.25%;
        margin-right: 1%;
        margin-top: 20px;
        border-radius: 7px;
        float: left;
        &:nth-of-type(4n){
            margin-right: 0;
        }
    }
    .ant-col-6:nth-of-type(4n){
        margin-right: 0px;
    }
    .ant-row{
        margin: 0 152px;
        display: block;
        // width: 1700px;
    }
    .all{
        background-color: #333333;
        padding-bottom: 83px;
    }
    .banner{
        width: 100%;
        height: 318px;
        background-image:url(../../assets/image/xx.png);
        background-size: 100% 100%;
    }
    .hotword1{
        font-size: 32px;
        color: #FFFFFF;
        width: 100%;
        text-align: center;
        padding-top: 66px;
    }
    // 搜索
    /deep/.ant-input-lg{
      font-size: 24px;
      padding: 14px 0px 13px 20px;
    }
    /deep/.ant-input-group{
        width: 585px;
        margin: 0 auto;
        margin-top: 27px;
    }
    /deep/.ant-input{
        height:50px;
        line-height: 50px;
    }
    /deep/.ant-input-search-button{
        border-radius: 0;
    }
    /deep/.ant-input-search-button:hover{
        background-color: #000000;
        border-color:#000000;
    }
    /deep/.ant-btn, .ant-btn:active, .ant-btn:focus{
        height: 52px;
        line-height: 52px;
        font-size: 24px;
        background-color: #000000;
        border-color:#000000;
    }

    }

</style>